import { Status } from ".";

export class Functionality{
    id: number;
    name: string;
    nameEnglish: string;
    status: Status = new Status();
    createdAt: Date = new Date();
    updatedAt: Date;
}
